export const NEED_HELP_TIMING_MODAL_NAME = 'needHelpTiming';
